import React from 'react';

export function DesktopBackground() {
  return (
    <>
      <div className="cover" />
      <div className="cover-fade" />
    </>
  );
}
